import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';
import { ConnectInitializeUser } from '../../../store/StoreTypes';
import { colors } from '../../../theme/colors';
import { FAQListItem } from './FAQListItem';
import { faqs } from './FAQs';
import { FontFamily } from './FontFamilies';
import { QRSection } from './QRSection';
import { References } from './References';
import { PDFEmail } from './svg/PDFEmail';
import { PDFMindsetLogo } from './svg/PDFMindsetLogo';
import { PDFNervaLogo } from './svg/PDFNervaLogo';

const PAGE_HEIGHT = 823;
const HEADER_HEIGHT = 60;
const FOOTER_HEIGHT = 44;
const BODY_HEIGHT = PAGE_HEIGHT - HEADER_HEIGHT - FOOTER_HEIGHT;

const SUPPORT_EMAIL = 'support@mindsethealth.com';

type Props = {
  hcpUser: ConnectInitializeUser;
};
// Create Document Component
export const OnePageDocument: FunctionComponent<Props> = (props) => (
  <Document pageLayout="singlePage">
    <Page size="A4" style={styles.page}>
      <Header />
      <Body hcpUser={props.hcpUser} />
      <Footer />
    </Page>
  </Document>
);

const Header: FunctionComponent = () => (
  <View style={styles.header}>
    <Text style={styles.headerTitle}>
      An Overview of Gut-Directed Hypnotherapy for Irritable Bowel Syndrome (IBS)
    </Text>
    <View style={styles.headerLogo}>
      <PDFNervaLogo />
      <View style={styles.logoDivider} />
      <PDFMindsetLogo />
    </View>
  </View>
);

const Body: FunctionComponent<Props> = (props) => (
  <View style={styles.body}>
    <View style={styles.bodyDivider} />

    {faqs.map((item, index) => (
      <FAQListItem key={`faq-list-item-${index}`} item={item} />
    ))}

    <QRSection hcpUser={props.hcpUser} />
    <References />
  </View>
);

const Footer: FunctionComponent = () => (
  <View style={styles.footer}>
    <View style={styles.footerSupport}>
      <PDFEmail />
      <Text>{SUPPORT_EMAIL}</Text>
    </View>
  </View>
);

const styles = StyleSheet.create({
  page: {
    backgroundColor: colors.white,
  },
  header: {
    backgroundColor: colors.green,
    color: colors.white,
    height: HEADER_HEIGHT,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 13.5,
    lineHeight: 1.3,
    paddingHorizontal: 30,
  },
  headerTitle: {
    fontFamily: FontFamily.TimesRoman,
    flex: 1,
  },
  headerLogo: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  logoDivider: {
    width: 1,
    backgroundColor: 'white',
    height: 22,
    transform: 'translateX(10px)',
  },
  body: {
    flex: 1,
    height: BODY_HEIGHT,
    paddingHorizontal: 30,
    paddingTop: 20,
    paddingBottom: 30,
    flexWrap: 'wrap',
    gap: 17,
    alignContent: 'space-between',
    position: 'relative',
  },
  bodyDivider: {
    width: 1,
    backgroundColor: colors.mutedGray,
    height: BODY_HEIGHT,
    position: 'absolute',
    top: 20,
    left: '55%',
  },
  footer: {
    height: FOOTER_HEIGHT,
    paddingHorizontal: 30,
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  footerSupport: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    fontSize: 8.5,
  },
});
